import { useTranslation } from "react-i18next";

import { useCenter } from "../../../center";
import CenterDetailsCard from "../components/CenterDetailsCard";
import CenterAdminShell from "../components/CenterAdminShell";
import CenterPatientFieldsSection from "../components/CenterPatientFieldsSection";
import CenterSessionPreferencesCard from "../components/CenterSessionPreferencesCard";

/**
 * The administrator's home, and the centre's settings: its own details, how
 * its sessions are created, and the extra fields each record carries.
 *
 * Deliberately organisational. The people in the centre have their own tab;
 * patients, agendas, reports, payments and tool policy each have theirs, with
 * an allow-list of what an administrator may see — which never includes a
 * note, a transcript or an analysis.
 */
export default function CenterAdminPage() {
    const { t } = useTranslation();
    const { center, loading } = useCenter();

    if (loading) {
        return <p className="p-6 text-sm text-gray-500">{t("common.loading")}</p>;
    }

    if (!center) {
        return <p className="p-6 text-sm text-gray-500">{t("center.notFound")}</p>;
    }

    return (
        <CenterAdminShell center={center}>
            <div className="flex flex-col gap-6">
                <CenterDetailsCard center={center} />
                <CenterSessionPreferencesCard center={center} />
                <CenterPatientFieldsSection centerId={center.id} />
            </div>
        </CenterAdminShell>
    );
}
